/**
 * HEADER COMPONENT
 * Top navigation and status bar
 */

import React from 'react';
import { Menu, Brain, Wifi, WifiOff, Settings } from 'lucide-react';
import { motion } from 'framer-motion';

interface HeaderProps {
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  activeView: string;
  sessionId: string;
  isConnected: boolean;
}

export function Header({ 
  sidebarOpen, 
  onToggleSidebar, 
  activeView, 
  sessionId, 
  isConnected 
}: HeaderProps) {
  return (
    <header className="h-16 border-b border-white/10 bg-white/5 backdrop-blur-sm flex items-center justify-between px-4">
      {/* Left Section */}
      <div className="flex items-center space-x-4">
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-lg hover:bg-white/10 transition-colors"
        >
          <Menu className="w-5 h-5 text-white" />
        </button>
        
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
            <Brain className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-white">CodeMind AI</h1>
          </div>
        </div>
      </div>

      {/* Center Section - Active View */}
      <div className="flex items-center space-x-2">
        <span className="text-sm text-slate-400">Current View:</span>
        <span className="text-sm font-medium text-white capitalize">{activeView}</span>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-4">
        {/* Connection Status */}
        <div className="flex items-center space-x-2">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="flex items-center space-x-1 text-green-400"
          >
            <Wifi className="w-4 h-4" />
            <span className="text-xs">Live on Cloudflare</span>
          </motion.div>
        </div>

        {/* Session ID */}
        <div className="text-xs text-slate-500">
          Session: {sessionId.slice(-8)}
        </div>

        {/* Settings */}
        <button className="p-2 rounded-lg hover:bg-white/10 transition-colors">
          <Settings className="w-4 h-4 text-slate-400" />
        </button>
      </div>
    </header>
  );
}